import React, { createContext, useContext, useState, useCallback } from 'react';

interface PageLoadingContextValue {
  isPageLoading: boolean;
  setPageLoading: (loading: boolean) => void;
}

const PageLoadingContext = createContext<PageLoadingContextValue>({
  isPageLoading: false,
  setPageLoading: () => {},
});

export const PageLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isPageLoading, setIsPageLoading] = useState(false);
  const setPageLoading = useCallback((loading: boolean) => setIsPageLoading(loading), []);
  return (
    <PageLoadingContext.Provider value={{ isPageLoading, setPageLoading }}>
      {children}
    </PageLoadingContext.Provider>
  );
};

export const usePageLoading = () => useContext(PageLoadingContext);
